"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _Info = _interopRequireDefault(require("../Info"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_TITLE_ALIGN = "end";

var HorizontalField = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(HorizontalField, _Component);

  var _super = _createSuper(HorizontalField);

  function HorizontalField() {
    var _this;

    (0, _classCallCheck2["default"])(this, HorizontalField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(HorizontalField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          popoverContent = _this$props.popoverContent,
          popoverMaxWidth = _this$props.popoverMaxWidth,
          popoverPosition = _this$props.popoverPosition,
          title = _this$props.title,
          required = _this$props.required,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          titleStyleProp = _this$props.titleStyle,
          popoverSentiment = _this$props.popoverSentiment;
      var negativeDarkest = this.context.theming.theme.negativeDarkest;
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);
      var titleSection = null;
      var titleStyle = null;

      if (typeof title == "string") {
        titleSection = /*#__PURE__*/_react["default"].createElement("section", null, title);
        titleStyle = (0, _styling.css)(this.styles.title, titleStyleProp);
      } else {
        titleSection = title();
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootCSS
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.titleContainer, titleStyle)
      }, titleSection, required && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: negativeDarkest,
          marginLeft: 5
        }
      }, "*"), popoverContent && /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        className: (0, _styling.css)(this.styles.info),
        popoverMaxWidth: popoverMaxWidth,
        popoverContent: popoverContent,
        size: 14,
        sentiment: popoverSentiment,
        position: popoverPosition || "top center"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.content)
      }, children));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props2 = this.props,
          titleWidth = _this$props2.titleWidth,
          _this$props2$titleAli = _this$props2.titleAlign,
          titleAlign = _this$props2$titleAli === void 0 ? DEFAULT_TITLE_ALIGN : _this$props2$titleAli,
          popoverContent = _this$props2.popoverContent,
          centerTitleVertically = _this$props2.centerTitleVertically,
          centerContentVertically = _this$props2.centerContentVertically;
      var _this$context$theming = this.context.theming,
          textDark = _this$context$theming.theme.textDark,
          fonts = _this$context$theming.fonts;
      var titleJustifyContent = "flex-end";

      if (titleAlign === "start") {
        titleJustifyContent = "flex-start";
      } else if (titleAlign === "center") {
        titleJustifyContent = "center";
      }

      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          "@media (max-width: 900px)": {
            alignItems: "stretch",
            flexDirection: "column"
          },
          "@media (min-width: 900px)": {
            alignItems: "center",
            flexDirection: "row"
          }
        },
        titleContainer: {
          display: "flex",
          "@media (min-width: 900px)": {
            width: titleWidth || 300,
            alignSelf: centerTitleVertically ? "center" : "flex-start"
          },
          "@media (max-width: 900px)": {
            alignSelf: "flex-start",
            marginBottom: 10
          },
          alignItems: popoverContent ? "center" : "flex-start",
          flexDirection: "row",
          justifyContent: titleJustifyContent
        },
        title: {
          fontSize: 16,
          color: textDark,
          fontFamily: fonts.regular,
          cursor: "default",
          lineHeight: 1.5,
          "@media (max-width: 900px)": {
            textAlign: "left"
          },
          "@media (min-width: 900px)": {
            textAlign: titleAlign === "start" ? "left" : "right"
          }
        },
        info: {
          marginLeft: 5
        },
        content: {
          "@media (min-width: 900px)": {
            marginLeft: 40
          },
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignSelf: centerContentVertically ? "center" : undefined
        }
      });
    }
  }]);
  return HorizontalField;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  title: {
    required: true,
    type: "string | (()=>ReactNode)",
    description: "Name of the field"
  },
  titleWidth: {
    required: false,
    type: "CSSProperties[\"width\"]",
    defaultValue: "300",
    description: "Width of the left (title) area"
  },
  titleStyle: {
    required: false,
    type: "CSSProperties",
    defaultValue: "null",
    description: "Apply some styling to the title element"
  },
  titleAlign: {
    required: false,
    type: "string",
    defaultValue: DEFAULT_TITLE_ALIGN,
    description: "Alignment of the title, can be one of \"start\", \"center\", or \"end\""
  },
  centerTitleVertically: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Whether to vertically center the title"
  },
  centerContentVertically: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Whether to vertically center the content"
  },
  popoverContent: {
    required: false,
    defaultValue: "null",
    type: "string | (() => ReactNode)",
    description: "Set if the field has additional info that needs to be " + " displayed with a popover. If set, an " + "[`Info`](/lego/component/Info) tip will be rendered next " + "to the title. And this value will be used as the popover content"
  },
  popoverMaxWidth: {
    required: false,
    defaultValue: "null",
    type: "number",
    description: "Set an optional maxWidth for the field's popover"
  },
  required: {
    required: false,
    defaultValue: "null",
    type: "boolean",
    description: "Adds an astrix to indicate field is required"
  },
  popoverSentiment: {
    required: false,
    defaultValue: "info",
    type: "\"success\" | \"warning\" | \"error\" | \"info\"",
    description: "Sentiment of the tip - determines the color treatment"
  }
}, _class3.demoProps = {
  title: "First Name",
  titleWidth: 100
}, _class3.demoRender = "\n  <HorizontalField title=\"First Name\" titleWidth={100}>\n  <RadioGroup\n    onSelected={() => {}}\n    popoverContent={\n      \"Company name must be consistent with name on Business License.\"\n    }\n    selectedValue={2}\n  >\n    <RadioGroup.Item value={1} text=\"Proof of your ID\" />\n    <RadioGroup.Item\n      value={2}\n      text=\"Proof of ownership of your online store URL\"\n    />\n  </RadioGroup>\n</HorizontalField>\n", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

exports["default"] = HorizontalField;